import React from 'react';
import Grid from '@material-ui/core/Grid';
// import Box from "@material-ui/core/Box";
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import i18n from 'helpers/i18n';
const styles = (theme) => {
  return {
    root: {
      height: '160px',
      width: '100%',
      backgroundColor: theme.palette.primary.main,
      padding: theme.spacing(2),
      '& .MuiTypography-h4, .MuiTypography-body1': {
        color: theme.palette.text.light,
      },
      [theme.breakpoints.down('sm')]: {
        height: 'auto',
      },
    },
    link: {
      fontSize: '1rem',
      fontWeight: 'bold',
      textDecoration: 'none',
      display: 'inline-block',
      color: theme.palette.text.light,
      '&:hover': {
        textDecoration: 'underline',
      },
      '&:visited': {
        color: theme.palette.text.light,
      },
    },
    alignCenter: {
      textAlign: 'center',
    },
  };
};

function Banner(props) {
  const { classes } = props;
  return (
    <Grid item container xs={12} alignItems="center" justify="space-around" className={classes.root}>
      <Grid item xs={12}>
        <Typography variant={'h4'} align="center">
          {i18n.get('bannerTitle')}
        </Typography>
      </Grid>
      <Grid
        container
        item
        xs={12}
        spacing={2}
        style={{ maxWidth: 700 }}
        alignItems="center"
        justify="space-around"
      >
        <Grid item xs={12} sm={6} className={classes.alignCenter}>
          <Link className={classes.link} to={'/help'} align="center">
            {i18n.get('bannerHelp')}
          </Link>
        </Grid>
        <Grid item xs={12} sm={6} className={classes.alignCenter}>
          <Link className={classes.link} to={'/contact'} align="center">
            {i18n.get('bannerContact')}
          </Link>
        </Grid>
      </Grid>
    </Grid>
  );
}
export default withStyles(styles)(Banner);



// WEBPACK FOOTER //
// ./src/components/Banner/Banner.jsx